// extracted by mini-css-extract-plugin
module.exports = {"pageMetaSection":"PageMetaSection_pageMetaSection__nsf9X"};